import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
import { useState } from 'react';
import { getLocationById, getLocationStorageKey, getPrimaryLocation } from './use-locations.utils';
import useStorageHook from '../../../../hooks/use-storage';
var defaultOptions = {
  initialActiveLocation: {},
  defaultToPrimary: false,
  useStorage: false,
  siteId: null
};
export default function useLocations(locations) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var finalOptions = _objectSpread(_objectSpread({}, defaultOptions), options);
  var defaultToPrimary = finalOptions.defaultToPrimary,
    useStorage = finalOptions.useStorage,
    siteId = finalOptions.siteId;
  var initialActiveLocation = finalOptions.initialActiveLocation;
  var primaryLocation = getPrimaryLocation(locations);
  if (defaultToPrimary) {
    initialActiveLocation = primaryLocation;
  }
  if (useStorage) {
    initialActiveLocation = primaryLocation; // used as default value
  }
  var _useStorageHook = useStorageHook(getLocationStorageKey(siteId), initialActiveLocation),
    _useStorageHook2 = _slicedToArray(_useStorageHook, 3),
    activeLocationStorage = _useStorageHook2[0],
    setActiveLocationStorage = _useStorageHook2[1],
    storageLoaded = _useStorageHook2[2];
  var _useState = useState(initialActiveLocation),
    _useState2 = _slicedToArray(_useState, 2),
    activeLocation = _useState2[0],
    setActiveLocation = _useState2[1];
  return {
    locations: locations,
    activeLocation: useStorage ? getLocationById(locations, activeLocationStorage === null || activeLocationStorage === void 0 ? void 0 : activeLocationStorage.id) || primaryLocation : activeLocation,
    setActiveLocation: useStorage ? setActiveLocationStorage : setActiveLocation,
    loaded: useStorage ? storageLoaded : true
  };
}